<template>
  <div class="cursor_detail">
    <!-- cursorDefault.png  :src="url"-->
    <div class="cursor_inner" @click="handCkick">
      <el-image
        style="width: 100%; height: 160px; display: block"
        :src="cursorDetail.cover || defaultImg"
        fit="cover"
      ></el-image>
      <div class="cursor_content" :style="{ height: dHeight + 'px' }">
        <div class="equal" ref="equal">
          <div class="title">
            <h4>{{ cursorDetail.title }}</h4>
          </div>
          <div class="detailed">
            <!-- <span
              >共
              {{
                cursorDetail.classHours / 60 / 45 == 0
                  ? "0"
                  : parseInt((cursorDetail.classHours / 60 / 45) * 100) / 100
              }}
              学时</span
            > -->
            <span>共1节课</span>
            <span class="progress">
              <template v-if="cursorDetail.studyProgress">
                已学{{ cursorDetail.studyProgress }}%
              </template>
              <template v-else>
                {{
                  Number(cursorDetail.classHours) > Number(cursorDetail.timeStudyed)
                    ? "未学完"
                    : "已学完"
                }}
              </template>
            </span>
          </div>
          <div class="end_time" v-if="cursorDetail.endTimeS">
            结束时间：{{ cursorDetail.endTimeS }}
          </div>
          <div class="end_time" v-if="cursorDetail.studyProgress">
            所属课程：{{ cursorDetail.courseName }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    cursorDetail: {
      type: Object,
      default: () => {
        return {};
      },
    },
    dHeight: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      defaultImg: require("@/assets/images/cursorDefault.png"),
    };
  },
  mounted() {
    // 等高方法
    this.$nextTick(() => {
      this.$emit("setEqual", this.$refs.equal.clientHeight);
    });
  },
  methods: {
    handCkick() {
      this.$emit("setHandleDetail", this.cursorDetail);
    },
  },
};
</script>
<style lang="scss" scoped>
.cursor_detail {
  //   width: 33.33%;
  padding: 0 13px;
  margin-bottom: 50px;
  .cursor_inner {
    padding-bottom: 20px;
    overflow: hidden;
    cursor: pointer;
    // box-shadow: 0px 0px 16px 0px rgba(247, 137, 25, 0.13);
    transition: all 0.3s;
    &:hover {
      transform: translateY(-4px);
      // box-shadow: 0px 0px 16px 0px rgba(247, 137, 25, 0.21);
    }
  }
}

.cursor_content {
  padding: 0px 10px;
  .equal {
    padding-top: 16px;
  }
  .title {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    margin-bottom: 10px;
    h4 {
      font-size: 18px;
      font-weight: bold;
      color: #333333;
      line-height: 1.3;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      flex: 1;
    }
  }
  .detailed {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #999999;
    font-size: 12px;
    .progress {
      padding: 4px 14px;
      background: #045923;
      border-radius: 10px;
      color: #fff;
      line-height: 1;
    }
  }
  .end_time {
    margin-top: 5px;
    color: #999999;
    font-size: 12px;
  }
}
</style>
